/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles(() => ({
  root: {
    "& > *": {
      width: "25ch",
    },
  },
}));

export default function UserEmailTextField({ onChange, typedEmailValidated }) {
  const classes = useStyles();
  return (
    <form className={classes.root} noValidate autoComplete={"off"}>
      <TextField
        error={false}
        onChange={onChange}
        id={"standard-error-helper-text"}
        label={"Email"}
        helperText={!typedEmailValidated ? "Invalid email." : null}
      />
    </form>
  );
}
